import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { SiteScriptListItem, getSiteScripts, runSiteScript } from '../../../api/adminClientApi';
import { Button } from '../../../designSystem/button/Button';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { SelectField } from '../../../designSystem/formField/SelectField';
import { Modal } from '../../../designSystem/Modal';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';

type SiteScriptModalButtonProps = {
    siteId: string,
    onUpdated?: () => void;
};

export function SiteScriptModalButton (props: SiteScriptModalButtonProps): JSX.Element
{
    const navigate = useNavigate();

    const [scripts, setScripts] = React.useState<SiteScriptListItem[]>([]);
    const [showModal, setShowModal] = React.useState(false);
    const [selectedScriptId, setSelectedScriptId] = React.useState('');
    const [running, setRunning] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');

    React.useEffect(() =>
    {
        const init = async () =>
        {
            const scripts = await getSiteScripts(() => navigate('/amorgy/login'));
            setScripts(scripts);
        };
        init().catch(console.error);
    }, []);

    function handleClickOpenModal ()
    {
        setSelectedScriptId('');
        setErrorMessage('');
        setShowModal(true);
    }

    async function handleClickRun ()
    {
        if (!selectedScriptId)
            return;

        setRunning(true);
        setErrorMessage('');

        const result = await runSiteScript(props.siteId, selectedScriptId, () => navigate('/amorgy/login'));
        setRunning(false);

        if (result.status === 'success') {
            setShowModal(false);
            props.onUpdated?.();
        } else {
            setErrorMessage(result.clientMessage);
        }
    }

    return (
        <>
            <LoadingPageOverlay loading={running} />

            <Button
                text="Data opsætning"
                variant='outlined'
                icon='navigation_settings'
                onClick={handleClickOpenModal} />

            <Modal
                title='Opsætning af data'
                showModal={showModal}
                onCancel={() => setShowModal(false)}
                content={
                    <Flex flexDirection="column" gap={16}>
                        <SelectField
                            label="Script"
                            emptyText="Vælg et datasæt til opsætning..."
                            options={scripts.map(s => ({ text: s.name, value: s.id }))}
                            selectedValue={selectedScriptId}
                            onChange={(value) => setSelectedScriptId(value)}
                        />

                        {selectedScriptId &&
                            <span>{scripts.find(s => s.id === selectedScriptId)?.description}</span>
                        }

                        {errorMessage &&
                            <span style={{ color: 'red' }}>Fejl: {errorMessage}</span>
                        }

                        <Button
                            text="Opret"
                            variant='filled'
                            onClick={handleClickRun}
                            disabled={!selectedScriptId || running} />
                    </Flex>
                }
            />
        </>
    );
}
